// extracted by mini-css-extract-plugin
export default {"project":"Project_project__fiLkT","buttonOpenProject":"Project_buttonOpenProject__t+1P9","imageProjectAndBtn":"Project_imageProjectAndBtn__g-Fg8"};